import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { ChevronRight, DeleteOutline, TextSnippetOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useFileDocument } from 'libs/uikit/src/hooks/useFileDocument';
import { openUrlWithNewWindow } from 'libs/uikit/src/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CommonFileItemView = function CommonFileItemView(props) {
  var className = props.className,
      info = props.info,
      _props$fileSource = props.fileSource,
      fileSource = _props$fileSource === void 0 ? 'quote' : _props$fileSource,
      _props$documentIdKey = props.documentIdKey,
      documentIdKey = _props$documentIdKey === void 0 ? 'document_id' : _props$documentIdKey,
      _props$documentNameKe = props.documentNameKey,
      documentNameKey = _props$documentNameKe === void 0 ? 'name' : _props$documentNameKe,
      clickItem = props.clickItem,
      showArrow = props.showArrow,
      token = props.token,
      showDelete = props.showDelete,
      deleteItem = props.deleteItem;

  var _useFileDocument = useFileDocument(),
      documentLoading = _useFileDocument.documentLoading,
      requestDocumentDetailInfo = _useFileDocument.requestDocumentDetailInfo,
      requestValidationDocumentDetailInfo = _useFileDocument.requestValidationDocumentDetailInfo;
  /**
   * methods
   */


  var openDocumentAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var _res, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.stopPropagation();

              if (!clickItem) {
                _context.next = 6;
                break;
              }

              clickItem();
              return _context.abrupt("return");

            case 6:
              res = {
                url: ''
              };

              if (!(fileSource === 'validation')) {
                _context.next = 13;
                break;
              }

              _context.next = 10;
              return requestValidationDocumentDetailInfo(info[documentIdKey], {
                token: token
              });

            case 10:
              res = _context.sent;
              _context.next = 16;
              break;

            case 13:
              _context.next = 15;
              return requestDocumentDetailInfo(info[documentIdKey]);

            case 15:
              res = _context.sent;

            case 16:
              openUrlWithNewWindow((_res = res) === null || _res === void 0 ? void 0 : _res.url);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openDocumentAction(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var deleteItemAction = function deleteItemAction(e) {
    e.stopPropagation();
    deleteItem === null || deleteItem === void 0 ? void 0 : deleteItem();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('boder-grey-30 flex cursor-pointer flex-row items-center space-x-1 rounded-lg border px-[10px] py-[6px]', className, {
      'cursor-wait': documentLoading
    }),
    onClick: function onClick(e) {
      return openDocumentAction(e);
    },
    children: [/*#__PURE__*/_jsx(TextSnippetOutlined, {
      className: "h-5 w-5 text-[#BB33D5]"
    }), /*#__PURE__*/_jsx("div", {
      className: "w-0 flex-1",
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "text-grey-70 truncate font-bold",
        children: info === null || info === void 0 ? void 0 : info[documentNameKey]
      })
    }), showArrow && /*#__PURE__*/_jsx(ChevronRight, {
      className: "h-5 w-5"
    }), showDelete && /*#__PURE__*/_jsx(DeleteOutline, {
      className: "h-5 w-5 cursor-pointer",
      onClick: deleteItemAction
    })]
  });
};